import { render } from "./Footer.vue?vue&type=template&id=bcfea5c8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=bcfea5c8&scoped=true&lang=css"

import exportComponent from "E:\\ismailDosyalar\\gifSites2\\gifSites\\2022\\gesas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfea5c8"]])

export default __exports__